import { createAuth0Client } from '@auth0/auth0-spa-js'
import React, { useEffect, useState } from 'react';

export const OAuthCallback = ({ auth0Config }) => {
  const [redirectPath, setRedirectPath] = useState(null);

  useEffect(() => {
    const doCallback = async () => {
      const searchParams = new URLSearchParams(window.location.search);
      console.log({searchParams})
      if (searchParams.get('error') !== null) {
        window.location.replace(`https://platform.cj.com/error${window.location.search}`)
      }

      // todo pull into hook
      const auth0Client = await createAuth0Client({
        domain: auth0Config.domain,
        clientId: auth0Config.clientId,
        connection: "email",
        authorizationParams: {
          redirect_uri: auth0Config.redirectUri,
          scope: 'openid profile email',
        },
      });

      auth0Client.handleRedirectCallback()
      .then(({ appState }) => {
        console.log({appState})
        setRedirectPath(appState.redirectPath)
      })
    }

    doCallback();
  }, [auth0Config.clientId, auth0Config.domain, auth0Config.redirectUri]);

  console.log({redirectPath})

  if (!!redirectPath) window.location.href = "/passwordless-login?destination=" + redirectPath
  return <></>
}